import { ItemType, RarityType } from "@apiserver-rest/ponder-data-client-base";

export function itemTypeToId(itemType: ItemType): number {
    switch (itemType) {
        case ItemType.None:
        default:
            return 0;

        case ItemType.Card:
            return 1;

        case ItemType.Sealed:
            return 2;
    }
}

export function rarityTypeToId(rarityType: RarityType): number {
    switch (rarityType) {
        case RarityType.Unknown:
        default:
            return 0;

        case RarityType.Common:
            return 1;

        case RarityType.Uncommon:
            return 2;

        case RarityType.Rare:
            return 3;

        case RarityType.Mythic:
            return 4;

        case RarityType.Special:
            return 5;

        case RarityType.Bonus:
            return 6;
    }
}